import { AdviceType } from "Store/advicePDF/interfaces";
import { useSelector } from "react-redux";
import {
  adviceTypeSelector,
  hasNewAdviceSelector,
  hasOldAdviceSelector,
} from "./akaAdviceSelectors";

export enum AdviceVersion {
  OLD = "OLD",
  NEW = "NEW",
}

export const useAdviceType = (): AdviceType => useSelector(adviceTypeSelector);

// TODO: Remove handling of old advice when no more old carts
export const useExistingAdviceVersion = (): AdviceVersion | undefined => {
  const hasOldAdvice = useSelector(hasOldAdviceSelector);
  const hasNewAdvice = useSelector(hasNewAdviceSelector);
  if (hasOldAdvice) {
    return AdviceVersion.OLD;
  }
  if (hasNewAdvice) {
    return AdviceVersion.NEW;
  }
  return undefined;
};
